module.exports = __webpack_public_path__ + "../resources/img/mon_graph_img5.e94ba645.png";